/** Web Push del dispositivo (founder 21-oct-2026). Permiso solo en el momento útil (al ver la primera cita / tras reservar). */
import { pushApi } from '@/lib/pushApi';
import { isIOS, isStandalone } from '@/pwa/PwaInstallContext';

export const PUSH_SNOOZE_KEY = 'ziyup_push_prompt_snoozed_at';
const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export const pushSupported = () => typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export const pushPermission = () => (pushSupported() ? Notification.permission : 'unsupported');
/** iPhone/iPad: el push web solo funciona con la app instalada en la pantalla de inicio. */
export const needsIosInstall = () => isIOS() && !isStandalone();
export const promptSnoozed = () => Date.now() - Number(localStorage.getItem(PUSH_SNOOZE_KEY) || 0) < SNOOZE_MS;
export const snoozePrompt = () => localStorage.setItem(PUSH_SNOOZE_KEY, String(Date.now()));

const b64ToU8 = (s) => {
  const pad = '='.repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

/** Pide permiso y registra la suscripción en el servidor. Devuelve 'granted' | 'denied' | 'unsupported'. */
export async function enablePush() {
  if (!pushSupported()) return 'unsupported';
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return perm;
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { public_key } = await pushApi.vapidKey();
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(public_key) });
  }
  await pushApi.subscribe(sub.toJSON());
  return 'granted';
}

/** Apaga el push: borra la suscripción del navegador y del servidor (en todos los dispositivos si `all`). */
export async function disablePush({ all = true } = {}) {
  const sub = await currentSubscription();
  if (sub) { try { await sub.unsubscribe(); } catch { /* ya no existe */ } }
  await pushApi.unsubscribe(all ? null : sub?.endpoint || null);
}
